import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Terminal, ArrowRight } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Access granted.");
      nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-md panel relative">
        <div className="border-b border-zinc-900 px-6 py-3 flex items-center gap-2">
          <Terminal className="w-4 h-4 text-[#FFB000]" />
          <span className="font-heading font-black tracking-tighter">DARA</span>
          <span className="font-mono text-[10px] text-zinc-500 ml-auto">AUTH://login</span>
        </div>
        <form onSubmit={submit} className="p-8 space-y-5">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mb-3">01 · ENTER TERMINAL</div>
            <h1 className="font-heading font-black text-3xl tracking-tighter uppercase">Welcome back,<br /> operator.</h1>
          </div>

          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Email</span>
            <input
              data-testid="login-email-input"
              type="email" required
              value={email} onChange={e => setEmail(e.target.value)}
              className="mt-2 w-full bg-black border border-zinc-800 px-3 py-2.5 font-mono text-sm text-white focus:outline-none focus:border-[#FFB000]"
            />
          </label>
          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Password</span>
            <input
              data-testid="login-password-input"
              type="password" required
              value={password} onChange={e => setPassword(e.target.value)}
              className="mt-2 w-full bg-black border border-zinc-800 px-3 py-2.5 font-mono text-sm text-white focus:outline-none focus:border-[#FFB000]"
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full bg-[#FFB000] text-black font-bold font-mono text-xs uppercase tracking-wider py-3 hover:bg-[#E59E00] transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {loading ? "AUTHENTICATING…" : <>Enter terminal <ArrowRight className="w-4 h-4" /></>}
          </button>

          <div className="text-center pt-2 space-y-2">
            <Link to="/forgot-password" data-testid="login-forgot-password-link" className="block font-mono text-[11px] text-zinc-500 hover:text-[#FFB000]">
              Forgot password?
            </Link>
            <Link to="/signup" data-testid="login-signup-link" className="block font-mono text-[11px] text-zinc-500 hover:text-white">
              No account? <span className="text-[#FFB000]">Request access →</span>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
